import { noop } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { filterToValidAttributes } from '@zocdoc/dom-property';

import PaddedContainer from '../PaddedContainer';

import {
    ZocdocLinkGroup,
    SpecialtiesLinkGroup,
    SEOLinkGroup,
    CTALinkGroup,
    CitiesLinkGroup,
    BadgeLinkGroup,
    BrowseLinkGroup,
    SearchLinkGroup,
} from './LinkGroups';

import {
    AppStoreLink,
    GooglePlayLink,
    MadeInNYLink,
    GooglePlusLink,
    FacebookLink,
    LinkedInLink,
    TwitterLink,
    StyledGooglePlayLink,
    StyledMadeInNYLink,
} from './IconLinks';

const StyledContainer = styled(PaddedContainer)`
    background-color: ${p => p.theme.footer.seo.bgColor};
    color: ${p => p.theme.footer.seo.textColor};
    display: flex;
    justify-content: space-between;
    padding-top: 30px;
    padding-bottom: 30px;

    > *:not(:first-child) {
        margin-left: 2vw;
    }
`;

const STRIP_SPACES_REGEX = /\s/g;

export class LinkFarm extends React.PureComponent {
    static propTypes = {
        showBadges: PropTypes.bool,
        showCities: PropTypes.bool,
        showCtas: PropTypes.bool,
        showSeo: PropTypes.bool,
        showSpecialties: PropTypes.bool,
        showZocdocLinks: PropTypes.bool,
        showPricingLink: PropTypes.bool,
        trackLinkClick: PropTypes.func,
    };

    static defaultProps = {
        showBadges: false,
        showCities: false,
        showCtas: false,
        showSeo: false,
        showSpecialties: false,
        showZocdocLinks: false,
        showPricingLink: false,
        trackLinkClick: noop,
    };

    render() {
        return (
            <StyledContainer {...filterToValidAttributes(this.props)}>
                {this.props.showZocdocLinks
                    ? <ZocdocLinkGroup onBeforeLinkClick={this.handleBeforeLinkClick} /> : null}
                {this.props.showSeo
                    ? <SEOLinkGroup onBeforeLinkClick={this.handleBeforeLinkClick} /> : null}
                {this.props.showCities
                    ? <CitiesLinkGroup onBeforeLinkClick={this.handleBeforeLinkClick} /> : null}
                {this.props.showSpecialties
                    ? <SpecialtiesLinkGroup onBeforeLinkClick={this.handleBeforeLinkClick} /> : null}
                {this.props.showCtas
                    ? <CTALinkGroup
                        onBeforeLinkClick={this.handleBeforeLinkClick}
                        {...this.props}
                    /> : null}
                {this.props.showBadges
                    ? <BadgeLinkGroup onBeforeLinkClick={this.handleBeforeBadgeClick} /> : null}
            </StyledContainer>
        );
    }

    /**
     * A handler for badge icons for GA Event Tracking
     */
    handleBeforeBadgeClick = async event => {
        const link = event.currentTarget;
        const linkName = link.getAttribute('data-link-name');

        const { trackLinkClick } = this.props;
        if (trackLinkClick) {
            await trackLinkClick({
                action: `Click ${linkName}`,
                Component: 'BadgeLinks',
                Element: linkName.replace(STRIP_SPACES_REGEX, ''),
            });
        }
    };

    /**
     * A generic onBeforeLinkClick handler for GA Event Tracking
     */
    handleBeforeLinkClick = async event => {
        // Proceed GA Tracking
        const eventTarget = event.currentTarget;
        const eventTargetText = eventTarget.textContent;

        const { trackLinkClick } = this.props;
        if (trackLinkClick) {
            await trackLinkClick({
                action: `Click ${eventTargetText}`,
                Component: `${eventTarget.getAttribute('data-title')}Links`,
                Element: eventTargetText.replace(STRIP_SPACES_REGEX, ''),
            });
        }
    }
}

export {
    ZocdocLinkGroup,
    SpecialtiesLinkGroup,
    SEOLinkGroup,
    CTALinkGroup,
    CitiesLinkGroup,
    BadgeLinkGroup,
    BrowseLinkGroup,
    SearchLinkGroup,
};

export {
    AppStoreLink,
    GooglePlayLink,
    MadeInNYLink,
    GooglePlusLink,
    FacebookLink,
    LinkedInLink,
    TwitterLink,
    StyledGooglePlayLink,
    StyledMadeInNYLink,
};

export default LinkFarm;
